<template>
  <v-app>
    <v-main class="background">
      <!-- Launcher del bot (flotante estilo iOS) -->
      <div class="launcher" @click="toggleChat" aria-label="Abrir chat">
        <v-avatar size="56" class="launcher-avatar">
          <img src="@/assets/bot.png" alt="Chat Ficenca">
        </v-avatar>
      </div>

      <!-- Chat estilo iOS -->
      <v-dialog
        v-model="isChatOpen"
        persistent
        max-width="420px"
        transition="dialog-bottom-transition"
        content-class="ios-dialog-overlay"
      >
        <v-card class="ios-chat-card">
          <!-- Header -->
          <v-card-actions class="ios-chat-header">
            <v-spacer></v-spacer>
            <div class="ios-chat-title">Ficenca Chat</div>
            <v-spacer></v-spacer>
            <v-btn icon class="ios-close-btn" @click="toggleChat" aria-label="Cerrar">X</v-btn>
          </v-card-actions>

          <!-- Mensajes -->
          <v-card-text class="ios-chat-body">
            <div
              v-for="message in messages"
              :key="message.id"
              class="row-message"
            >
              <div
                :class="[
                  'bubble',
                  message.sender === 'bot' ? 'bot-bubble' : 'user-bubble'
                ]"
                v-html="message.text"
              ></div>
            </div>
          </v-card-text>

          <v-divider class="ios-divider"></v-divider>

          <!-- Acciones rápidas -->
          <v-card-actions class="ios-quick-actions">
            <v-btn class="pill" rounded @click="selectOption('Ubicación')">
              Ver ubicación
            </v-btn>
            <v-btn class="pill" rounded @click="selectOption('Contacto')">
              Ver contacto
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    isChatOpen: false,
    messages: [
      { id: 1, sender: 'bot', text: '¡Hola! Bienvenido al chat de Ficenca. ¿En qué podemos ayudarte?' }
    ]
  }),
  methods: {
    toggleChat() {
      this.isChatOpen = !this.isChatOpen
    },
    selectOption(option) {
      this.messages.push({ id: Date.now(), sender: 'user', text: option })
      this.replyToOption(option)
    },
    replyToOption(option) {
      let reply = ''
      if (option === 'Ubicación') {
        reply = 'Estamos ubicados en bodega # 2 Av. 55, Vuelta del Virilla, Uruca, San José.'
      } else if (option === 'Contacto') {
        reply = `Puedes contactarnos por:<br>
        <strong>- Administrativo:</strong><br> (506) 2231-0010 · (506) 2265-2888<br><br>
        <strong>- Departamento de Ventas:</strong><br> (506) 8995-6226 · (506) 8731-5650<br><br>
        <strong>- Servicio Técnico:</strong><br> (506) 7174-7038 · (506) 2231-0010`
      } else {
        reply = '¿En qué más puedo ayudarte?'
      }
      setTimeout(() => {
        this.messages.push({ id: Date.now(), sender: 'bot', text: reply })
      }, 400)
    }
  }
}
</script>

<style>
/* Fondo original */
.background {
  color: #33b328;
  background-image: url('https://grupoficenca.com/img/background.png');
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}

/* ===== Launcher iOS ===== */
.launcher {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 10000;
  cursor: pointer;
}
.launcher-avatar {
  box-shadow: 0 10px 24px rgba(0,0,0,0.22), 0 2px 6px rgba(0,0,0,0.12);
  background: #ffffff;
  transition: transform .15s ease, box-shadow .2s ease;
}
.launcher-avatar:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(0,0,0,0.24), 0 4px 10px rgba(0,0,0,0.12);
}

/* ===== Dialog/Card estilo iOS ===== */
.ios-dialog-overlay { backdrop-filter: blur(2px); }

.ios-chat-card {
  height: 520px;
  display: flex;
  flex-direction: column;
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0,0,0,0.18);
  background: #fff;
}

/* Header tipo iMessage */
.ios-chat-header {
  position: relative;
  height: 48px;
  background: #f7f7f7;
  border-bottom: 1px solid #e5e5ea;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.ios-chat-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  color: #111;
  letter-spacing: -0.2px;
}
.ios-close-btn { color: #111 !important; }

/* Área de mensajes */
.ios-chat-body {
  flex: 1;
  background: #fff;
  padding: 12px 12px 0 12px;
  overflow-y: auto;
}

/* Mensajes */
.row-message { display: flex; margin: 6px 0; }
.bubble {
  max-width: 78%;
  padding: 10px 12px;
  border-radius: 18px;
  line-height: 1.45;
  word-break: break-word;
  font-size: 14.5px;
}
.bot-bubble {
  background: #f2f2f7;
  color: #111;
  border-top-left-radius: 6px;
  margin-right: auto;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,0.04);
}
.user-bubble {
  background: #0a84ff;
  color: #fff;
  border-top-right-radius: 6px;
  margin-left: auto;
  box-shadow: 0 2px 6px rgba(10,132,255,0.35);
}

/* Separador y acciones rápidas */
.ios-divider { opacity: 0.6; }

.ios-quick-actions {
  gap: 8px;
  padding: 10px 12px 14px;
  display: flex;
  justify-content: center;
}
.pill {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  font-size: 12.5px !important;
  padding: 8px 14px !important;
  border-radius: 999px !important;
  background: #e9f2ff !important;
  color: #0a84ff !important;
  box-shadow: none !important;
}
.pill:hover { background: #d9eaff !important; }
</style>
